import { useLayoutEffect, useRef, useState } from 'react';

export function useDynamicContainerHeight(extraPx: number) {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const [childNode, setChildNode] = useState<HTMLElement | null>(null);

	useLayoutEffect(() => {
		const container = containerRef.current;
		if (!container || !childNode) return;

		const observer = new ResizeObserver((entries) => {
			for (const entry of entries) {
				const height = entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height;

				if (height > 0) {
					const newHeight = Math.ceil(height) + extraPx;
					container.style.minHeight = `${newHeight}px`;
					container.style.transition = 'min-height 0.2s ease-out';
				}
			}
		});

		observer.observe(childNode);

		const initialRect = childNode.getBoundingClientRect();
		if (initialRect.height > 0) {
			container.style.minHeight = `${Math.ceil(initialRect.height) + extraPx}px`;
		}

		return () => observer.disconnect();
	}, [childNode, extraPx]);

	return { containerRef, setChildRef: setChildNode };
}
